export default __webpack_public_path__ + "static/mysql-1-88631d0de40f60cec048c5f2549eaf37.svg";